export const SISTEMA_RUTAS = {
    "Mi Habitat Digital": /^\/mi-habitat-digital(\/.*)?$/,
    "Zona de Beneficiarios": /^\/zona-beneficiarios(\/.*)?$/,
    "Web Pública": /^(\/|\/genera-clave-web)$/,
};